export default __webpack_public_path__ + "static/media/gs.269d2a73.svg";